"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClinicalKeywordsTable = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const styles_1 = require("../styles");
const messages_1 = __importDefault(require("../../../common/util/constants/messages"));
exports.ClinicalKeywordsTable = (0, intl_1.injectIntl)(({ id, labels: { tableHeaderLabel, nextPageLabel, previousPageLabel, noRecordsLabel, noRecordsOnSearchLabel }, clinicalKeywords, isLoading, stateEventHandlers, intl }) => {
    const sortProps = react_1.default.useMemo(() => ({
        sortBy: [{ id: 'name', desc: false }]
    }), []);
    const paginatorProps = react_1.default.useMemo(() => ({
        pageSize: 10,
        currentPage: 0,
        nextPageRenderer: () => nextPageLabel,
        previousPageRenderer: () => previousPageLabel,
        totalCount: clinicalKeywords.length,
        showOutOf: true
    }), [clinicalKeywords.length, nextPageLabel, previousPageLabel]);
    const columns = react_1.default.useMemo(() => [
        {
            id: 'name',
            accessor: 'name',
            Header: tableHeaderLabel
        }
    ], [tableHeaderLabel]);
    return (react_1.default.createElement(styles_1.Table, { striped: true, id: id, isLoading: isLoading, columns: columns, data: clinicalKeywords, sortProps: sortProps, paginatorProps: paginatorProps, noResultsMessage: (isFiltered) => isFiltered ? noRecordsOnSearchLabel : noRecordsLabel, stateEventHandlers: stateEventHandlers, ariaProps: {
            ariaLiveLabel: (count) => intl.formatMessage(messages_1.default.ariaLiveSearchResultCount, {
                count
            })
        } }));
});
//# sourceMappingURL=ClinicalKeywordsTable.js.map